import { Button } from '@components/inputs/Button'
import { useAuth } from '@libs/useAuth'
import Box from '@components/base/Box'
import LoadingSpinner from '@components/base/LoadingSpinner'
import Logo from '@public/images/ForummLogo.svg'
import React, { useEffect, useState, useRef } from 'react'
import Link from 'next/link'
import { TextInput } from '@components/inputs/TextInput'
import { Form } from '@components/inputs/Form'
import { PASSWORD_PATTERN } from '@libs/Utility/validation'
import { useRouter } from 'next/router'

const SignUpForm = () => {
  const { signInWithEmail, acceptTcPp, profile, isLogged } = useAuth()

  const [userData, setUserData] = useState(null)
  const hasSignedInRef = useRef(isLogged)

  const signIn = async (password: string) => {
    if (!hasSignedInRef.current && typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search)
      const email = decodeURIComponent(urlParams.get('email') ?? '')
      console.log({ email, urlParams })

      if (email && password) {
        try {
          const response = (await signInWithEmail(
            email ?? profile?.email,
            password
          )) as any
          const {
            idToken: { payload },
          } = response
          setUserData(payload)
          hasSignedInRef.current = true
        } catch (error) {
          console.error('Error during automatic sign-in:', error)
          setSignInError((error as any).message)
        }
      }
    }
  }

  const [loading, setLoading] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [signInError, setSignInError] = useState<string>()
  const router = useRouter()

  useEffect(() => {
    if (userData?.['custom:acceptedTcPp'] === 'TRUE') {
      if (
        router.query.previous &&
        !document.referrer.includes('www.forumm.to') &&
        !document.referrer.includes('//forumm.to')
      )
        router.back()
      else window.location.href = '/dashboard'
    }
  }, [userData])

  const handleAcceptAndContinue = async () => {
    await acceptTcPp()
    if (!router.route.includes('verify-account')) return
    //@ts-ignore
    const isOrganizer = userData?.['cognito:groups']?.includes('organizer')
    if (
      router.query.previous &&
      !document.referrer.includes('www.forumm.to') &&
      !document.referrer.includes('//forumm.to')
    )
      router.back()

    if (isOrganizer) {
      window.location.href = '/create-event'
      return
    }
    window.location.href = '/dashboard'
  }

  console.log({
    userData,
    profile,
    isLogged,
    fullName: userData?.['custom:fullName'],
    acceptedTcPp: userData?.['custom:acceptedTcPp'],
    cond1: !userData?.['custom:fullName'],
    cond2: userData?.['custom:acceptedTcPp'],
  })
  if (
    (isLogged &&
      !!profile &&
      !profile?.fullName &&
      !userData?.['custom:fullName']) ||
    userData?.['custom:acceptedTcPp'] === 'TRUE'
  ) {
    return (
      <Box className="w-full min-h-screen" color={'backgroundColour'}>
        <Box
          className="w-full mx-auto md:w-1/2 my-16 p-10"
          color={'backgroundColourSecondary'}
        >
          <Box className="text-white text-center text-2xl font-bold pl-3 md:pl-0 mb-8">
            Welcome to Forumm
            <Logo className="inline-block w-12" />
          </Box>
          <Box className="w-full flex justify-center">
            {loading ? (
              <LoadingSpinner size="large" />
            ) : (
              <Form
                error={signInError}
                onSubmit={async (data) => {
                  const { password } = data
                  setLoading(true)
                  await signIn(password).then(() => setLoading(false))
                }}
              >
                <p className="mb-8">
                  Please provide your account password to continue.
                </p>
                <Box className="relative">
                  <TextInput
                    placeholder={'Enter your password'}
                    type={'password'}
                    validations={{
                      minLength: {
                        value: 8,
                        message:
                          'Password is too short (minimum: 8 characters)',
                      },
                      maxLength: {
                        value: 50,
                        message: 'Password is too long',
                      },
                    }}
                    ignoreDefaultValidations={true}
                    required
                    label={'Password'}
                  />
                </Box>
                <Button
                  buttonType="submit"
                  title="Continue"
                  className="ml-auto"
                />
              </Form>
            )}
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box className="w-full min-h-screen" color={'backgroundColour'}>
      <Box
        className="w-full md:w-1/2 my-16 mx-auto rounded p-10"
        color={'backgroundColourSecondary'}
      >
        <Box className="text-white text-center text-2xl font-bold pl-3 md:pl-0 mb-8">
          Welcome to Forumm
          <Logo className="inline-block w-12" />
        </Box>
        <Box className="w-full text-center items-center justify-center">
          <span className="mt-8">
            Welcome, <strong>{userData?.['custom:fullName']}</strong>!
          </span>
          <p className="mt-4">
            Before continuing, please review our&nbsp;
            <Link
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-forumm-blue underline hover:text-forumm-blue font-medium"
            >
              Privacy Notice
            </Link>
            .
          </p>
          <p className="mb-8">
            By clicking &quot;Accept and Continue&quot;, you consent.
          </p>
          <Button
            onClick={handleAcceptAndContinue}
            title="Accept and Continue"
            className="mt-4 w-full"
          />
        </Box>
      </Box>
    </Box>
  )
}

export default SignUpForm
